import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

/**
 * Bloco padrão das seções da landing.
 *
 * Centraliza espaçamento vertical, largura máxima e o par título/subtítulo,
 * garantindo ritmo visual consistente e um único `h2` por seção (acessibilidade
 * e leitura por tecnologia assistiva).
 */
export default function Section({
  id,
  eyebrow,
  title,
  subtitle,
  children,
  maxWidth = 'lg',
  align = 'left',
  sx,
}) {
  return (
    <Box
      component="section"
      id={id}
      sx={{ py: { xs: 7, md: 12 }, scrollMarginTop: 88, ...sx }}
    >
      <Container maxWidth={maxWidth}>
        {(eyebrow || title || subtitle) && (
          <Stack
            spacing={1.5}
            sx={{
              mb: { xs: 4, md: 6 },
              maxWidth: align === 'center' ? 760 : 820,
              mx: align === 'center' ? 'auto' : 0,
              textAlign: align,
            }}
          >
            {eyebrow && (
              <Typography
                variant="overline"
                sx={{ color: 'secondary.main', letterSpacing: '0.18em', fontWeight: 700 }}
              >
                {eyebrow}
              </Typography>
            )}
            {title && (
              <Typography variant="h3" component="h2" sx={{ fontSize: { xs: 28, md: 40 } }}>
                {title}
              </Typography>
            )}
            {subtitle && (
              <Typography variant="subtitle1" color="text.secondary">
                {subtitle}
              </Typography>
            )}
          </Stack>
        )}
        {children}
      </Container>
    </Box>
  );
}
